import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const MONTH_NAMES = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

const daysInMonth = (month) => new Date(2024, month, 0).getDate();

const FiscalYearConfig = ({ open, onClose, onSave, initialConfig }) => {
  const [startMonth, setStartMonth] = useState(1);
  const [startDay, setStartDay]   = useState(1);
  const [endMonth, setEndMonth]   = useState(12);
  const [endDay, setEndDay]       = useState(31);

  useEffect(() => {
    if (!open) return;
    setStartMonth(initialConfig?.startMonth ?? 1);
    setStartDay(initialConfig?.startDay ?? 1);
    setEndMonth(initialConfig?.endMonth ?? 12);
    setEndDay(initialConfig?.endDay ?? 31);
  }, [open, initialConfig]);

  const startDays = Array.from({ length: daysInMonth(startMonth) }, (_, i) => i + 1);
  const endDays   = Array.from({ length: daysInMonth(endMonth)   }, (_, i) => i + 1);

  const today = new Date();
  const fyStartThisYear = new Date(today.getFullYear(), startMonth - 1, startDay);
  const fyStartYear = today >= fyStartThisYear ? today.getFullYear() : today.getFullYear() - 1;
  const fyStart = new Date(fyStartYear, startMonth - 1, startDay);
  const endIsNextYear = endMonth < startMonth || (endMonth === startMonth && endDay < startDay);
  const fyEndYear = endIsNextYear ? fyStartYear + 1 : fyStartYear;
  const fyEnd = new Date(fyEndYear, endMonth - 1, endDay);
  const fmt = (d) => d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

  const selectStyle = { fontSize: 13 };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle style={{ paddingBottom: 8 }}>Fiscal Year Settings</DialogTitle>
      <DialogContent style={{ paddingTop: 4 }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 8 }}>Starts</div>
          <div style={{ display: "flex", gap: 8 }}>
            <Select value={startMonth} onChange={(e) => setStartMonth(Number(e.target.value))} variant="outlined" style={{ flex: 1, ...selectStyle }}>
              {MONTH_NAMES.map((name, i) => <MenuItem key={i + 1} value={i + 1}>{name}</MenuItem>)}
            </Select>
            <Select value={startDay} onChange={(e) => setStartDay(Number(e.target.value))} variant="outlined" style={{ width: 80, ...selectStyle }}>
              {startDays.map((d) => <MenuItem key={d} value={d}>{d}</MenuItem>)}
            </Select>
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 8 }}>Ends</div>
          <div style={{ display: "flex", gap: 8 }}>
            <Select value={endMonth} onChange={(e) => setEndMonth(Number(e.target.value))} variant="outlined" style={{ flex: 1, ...selectStyle }}>
              {MONTH_NAMES.map((name, i) => <MenuItem key={i + 1} value={i + 1}>{name}</MenuItem>)}
            </Select>
            <Select value={endDay} onChange={(e) => setEndDay(Number(e.target.value))} variant="outlined" style={{ width: 80, ...selectStyle }}>
              {endDays.map((d) => <MenuItem key={d} value={d}>{d}</MenuItem>)}
            </Select>
          </div>
        </div>

        <div style={{ background: "#f0f4ff", borderRadius: 6, padding: "10px 12px", fontSize: 12, color: "#374151" }}>
          <div style={{ fontWeight: 600, marginBottom: 2 }}>This fiscal year</div>
          <div style={{ color: "#6b7280" }}>{fmt(fyStart)} – {fmt(fyEnd)}</div>
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "12px 16px" }}>
        <Button onClick={onClose} size="small">Cancel</Button>
        <Button
          onClick={() => onSave({ startMonth, startDay, endMonth, endDay })}
          color="primary" variant="contained" size="small" disableElevation
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FiscalYearConfig;
